/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Gym_One_DetailInputs */

const en_features_gym_one_detail = /** @type {(inputs: Features_Gym_One_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free weights · 4 racks · cables`)
};

const pl_features_gym_one_detail = /** @type {(inputs: Features_Gym_One_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wolne ciężary · 4 klatki · wyciągi`)
};

/**
* | output |
* | --- |
* | "Free weights · 4 racks · cables" |
*
* @param {Features_Gym_One_DetailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_gym_one_detail = /** @type {((inputs?: Features_Gym_One_DetailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Gym_One_DetailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_gym_one_detail(inputs)
	return en_features_gym_one_detail(inputs)
});